module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pages-home"
  }, [_c('Loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }), (_vm.props && !_vm.loading) ? _c('div', {
    staticClass: "homepage"
  }, [_c('Header'), _c('div', {
    staticClass: "banner_block"
  }, [_c('video', {
    staticClass: "video",
    attrs: {
      "autoplay": "",
      "loop": "",
      "muted": ""
    },
    domProps: {
      "muted": true
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.props.acf.home_background_video,
      "type": "video/mp4"
    }
  })]), _c('div', {
    staticClass: "innerhm"
  }, [_c('div', {
    staticClass: "innerhm1"
  }, [_c('div', {
    staticClass: "innerhm2"
  }, [_c('div', {
    staticClass: "sec_1_content",
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.homepage_section1_title)
    }
  })])])])]), _c('div', {
    staticClass: "alaleh_block"
  }, [(_vm.props.acf.avatar_image) ? _c('div', {
    staticClass: "avatar",
    style: ({
      backgroundImage: 'url(' + _vm.props.acf.avatar_image + ')'
    })
  }) : _vm._e(), _c('div', {
    staticClass: "card"
  }, [_vm._m(0), _c('h1', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.section2_heading)
    }
  }), _c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.section2_sub_heading)
    }
  }), _c('hr'), _c('div', {
    staticClass: "contentt",
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.section2_content)
    }
  })])]), _c('div', {
    staticClass: "special_block"
  }, [_c('span', {
    staticClass: "all_hd",
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.special_title)
    }
  }), _c('hr', {
    staticClass: "all_hr"
  }), _c('div', {
    staticClass: "boxes"
  }, [(_vm.props.acf.block_one.image) ? _c('div', {
    staticClass: "box",
    style: ({
      backgroundImage: 'url(' + _vm.props.acf.block_one.image + ')'
    })
  }, [_c('h1', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.block_one.title)
    }
  }), _c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.block_one.price)
    }
  }), _c('router-link', {
    attrs: {
      "to": _vm.props.acf.block_one.link
    }
  }, [_vm._v("learn more")])], 1) : _vm._e(), (_vm.props.acf.block_two.background_image) ? _c('div', {
    staticClass: "box",
    style: ({
      backgroundImage: 'url(' + _vm.props.acf.block_two.background_image + ')'
    })
  }, [_c('h2', [_c('img', {
    attrs: {
      "src": _vm.props.acf.block_two.image,
      "alt": "flame"
    }
  }), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.block_two.title)
    }
  })]), _c('h1', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.block_two.content)
    }
  }), _c('router-link', {
    attrs: {
      "to": _vm.props.acf.block_two.link
    }
  }, [_vm._v("click here")])], 1) : _vm._e()])]), _vm._m(1), _c('div', {
    staticClass: "specials"
  }, [_c('div', {
    staticClass: "schedule_appoint_section"
  }, [_c('h1', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.section_4_content.title)
    }
  }), _c('hr', {
    staticClass: "all_hr"
  }), _c('div', {
    staticClass: "email-container"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "company-info"
  }, [_c('ul', [_c('li', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.section_4_content.address)
    }
  }), _c('li', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.section_4_content.phone)
    }
  }), _c('br'), _c('br'), _c('li', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.section_4_content.hours)
    }
  })])]), _c('div', {
    staticClass: "contact"
  }, [_c('h3', [_vm._v("Email Us")]), _c('div', {
    staticClass: "appoint-wrap contact-form"
  }, [_c('CustomForm')], 1)])])])])]), _c('Footer')], 1) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mouse"
  }, [_c('span')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "review-home"
  }, [_c('div', {
    staticClass: "reviews-get-page"
  }, [_c('iframe', {
    staticClass: "yelp-review",
    attrs: {
      "src": "https://www.lakewashingtondentist.com/review-section/",
      "width": "100%",
      "allowtransparency": "true"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-40c6bb22","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/pages/404/404.pug
// module id = 540
// module chunks = 1